export default __webpack_public_path__ + "static/media/Bookshelf.1791e55a.jpg";